import Dispatcher from "Dispatcher";
import DefineActions from "jsmodel/DefineActions";

export default function _unload() {
    for (const k in Hybrid) {
        if (Hybrid.hasOwnProperty(k) && k.indexOf("/") > 0) {
            delete Hybrid[k];
        }
    }
    Dispatcher.dispatch({
        type: DefineActions._UNLOAD,
    });
};



// WEBPACK FOOTER //
// ./app/jsmodel/_unload.js